'use strict';

var React = require('react');

class NotFoundLegacyComponent extends React.Component {
	render() {
		return (
			<div>
				<div className="svtseLocalHeader svtXBgColorLightLightBlue svtXPadding-Bottom-15px">
					<div className="svtContainerBase svtseLocalHeaderHeight-THEMED">
						<h1 className="svtLocalLogo-404 svtLocalLogoTHEMED-404">404 Not Found</h1>
					</div>
				</div>
				<div className="svtContainerBase">
					<article className="svtContainerFull svtXMargin-Top-50px svtXMargin-Bottom-50px svtXMaxWidth50em">
						<h2 className="svtH2 svtXMargin-Bottom-30px">Oj, sidan finns inte </h2>
						<p className="svtXMargin-Bottom-5px">På den här adressen finns ingen sida. Den kan ha tagits bort eller så kan det vara något fel på länken.</p>
						<ul className="svtXMargin-Bottom-50px">
							<li>Prova att <a href="http://www.svt.se/search">söka efter det du vill finna</a></li>
							<li>Kolla om adressen är rätt inskriven</li>
							<li>Visa alla <a href="http://www.svt.se/program/?filter=program">program</a> i en A-Ö lista</li>
						</ul>
						<p>Hjälp oss gärna genom att <a href="http://kontakt.svtplay.se/" className="svtJsError404">berätta för SVT.se-redaktionen om hur du hamnade här.</a></p>
					</article>
				</div>
			</div>
		);

	}
}

module.exports = NotFoundLegacyComponent;




/** WEBPACK FOOTER **
 ** ./app/components/NotFoundHandler/NotFoundLegacyComponent.jsx
 **/